import { render, staticRenderFns } from "./FundMember.vue?vue&type=template&id=70d7ade5"
import script from "./FundMember.vue?vue&type=script&lang=js"
export * from "./FundMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports